export { AboutThisEventModal, type AboutThisEventModalProps } from './AboutThisEventModal';
